import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MainContent, MainContentMobile } from ".";
import { useViewport } from "../../../utils";
import dummy from "../data";
import { defaultSortOptions, sorter } from "../../../utils";
import { useLocation } from "react-router-dom";
import { fetchOrganizations } from "../../../features/organizations/slice";
import { fetchPrograms } from "../../../features/programs/slice";
import { fetchEvents } from "../../../features/events/slice";
import { fetchResources } from "../../../features/resources/slice";
import { fetchBlogs } from "../../../features/blogs/slice";
// import qs from 'query-string';

/**
 * search results length
 *  organization
 *  program
 *  event
 *  resources
 *  blog
 */

const PageContent = ({ query }) => {
  const dispatch = useDispatch()
  const { isDesktop } = useViewport();
  const location = useLocation();
  const [data, setData] = useState(dummy[location.pathname]);
  const organizations = useSelector(state => state.organizations.data)
  const programs = useSelector(state => state.programs.data)
  const events = useSelector(state => state.events.data)
  const resources = useSelector(state => state.resources.data)
  const blogs = useSelector(state => state.blogs.data)
  // const queryString = useSelector(state => state.search.queryString)

  const [countData, setCountData] = useState({
    "/program": 0,
    "/organization": 0,
    "/event": 0,
    "/resource": 0,
    "/blog": 0
  })

  const getSortOptions = () => {
    const options = ["date", "name"];
    return defaultSortOptions.filter((a) => options.includes(a.key));
  };

  const sortOptions = getSortOptions();

  const handleSort = ({ value, key }) => sorter(value, key, data, setData);

  useEffect(() => {
    // Option 1: Dummy action
    setData(dummy[location.pathname])

    // Option 2: Real action
    // Location to API object key converter
    let apiKey =
      location.pathname === '/search-results/organization' ? 'organizations'
      : location.pathname === '/search-results/event' ? 'events'
      : location.pathname === '/search-results/resource' ? 'resources'
      : location.pathname === '/search-results/blog' ? 'blogs'
      : location.pathname === '/search-results/program' ? 'programs'
      : false

    switch (apiKey) {
      // For now, lets just try to Organization collection
      case 'organizations':
        // Just trigger fetching. Fetch result will be handle by other useEffect
        dispatch(fetchOrganizations(query))
        break;
      case 'programs':
        dispatch(fetchPrograms(query))
        break;
      case 'events':
        dispatch(fetchEvents(query))
        break;
      case 'resources':
        dispatch(fetchResources(query))
        break;
      case 'blogs':
        dispatch(fetchBlogs(query))
        break;
      default:
        break;
    }
  }, [dispatch, query, location])

  useEffect(() => {
    // (Organization Only)
    let apiKey =
      location.pathname === '/search-results/organization' ? 'organizations'
      : location.pathname === '/search-results/event' ? 'events'
      : location.pathname === '/search-results/resource' ? 'resources'
      : location.pathname === '/search-results/blog' ? 'blogs'
      : location.pathname === '/search-results/program' ? 'programs'
      : false

    // let apiKey = location.pathname === '/search-results/organization' ? 'organizations' : false
    // if(apiKey === 'organizations'){
    //   setData(organizations)
    // }

    switch (apiKey) {
      case 'organizations':
        setData(organizations)
        break;
      case 'programs':
        setData(programs)
        break;
      case 'events':
        setData(events)
        break;
      case 'resources':
        setData(resources)
        break;
      case 'blogs':
        setData(blogs)
        break;
      default:
        break;
    }
  }, [organizations, programs, events, resources, blogs, location])

  // Fetch all data with provided query
  useEffect(() => {
    // const newQueryString = '?'+qs.stringify(query)
    // console.log({newQueryString, queryString})
    // if(newQueryString !== queryString){
      const fetchHelper = (fetcher) => dispatch(fetcher(query)).then(res => res.payload.count)

      const promiseObject = {
        0: {
          route: '/program',
          promise: fetchHelper(fetchPrograms)
        },
        1: {
          route: '/organization',
          promise: fetchHelper(fetchOrganizations)
        },
        2: {
          route: '/event',
          promise: fetchHelper(fetchEvents)
        },
        3: {
          route: '/resource',
          promise: fetchHelper(fetchResources)
        },
        4: {
          route: '/blog',
          promise: fetchHelper(fetchBlogs)
        },
      }

      const promises = Object.keys(promiseObject).map(key => promiseObject[key].promise)

      Promise.all(promises).then(res => {
        const newCountData = {}

        if(res && res.length > 0){
          for (let index = 0; index < res.length; index++) {
            const element = res[index];
            newCountData[promiseObject[index].route] = element
          }
        }

        console.log('newCountData:', newCountData)
        setCountData(newCountData)
      })
    // }

    // eslint-disable-next-line
  }, [query])

  return (
    <>
      {isDesktop ? (
        <MainContent
          query={query}
          data={data}
          sortOptions={sortOptions}
          handleSort={handleSort}
          countData={countData}
        />
      ) : (
        <MainContentMobile
          query={query}
          data={data}
          sortOptions={sortOptions}
          handleSort={handleSort}
          countData={countData}
        />
      )}
    </>
  );
};

export { PageContent };
